import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20composition%20with%20soft%20golden%20amber%20and%20cream%20tones%2C%20flowing%20ink%20brush%20strokes%20creating%20elegant%20texture%2C%20minimalist%20literary%20aesthetic%2C%20calligraphy%20ink%20diffusion%20in%20water%2C%20gentle%20gradient%20background%2C%20subtle%20paper%20texture%2C%20warm%20atmospheric%20lighting%2C%20artistic%20and%20poetic%20mood%2C%20no%20text%20or%20letters%2C%20pure%20visual%20texture%20composition&width=1600&height=900&seq=hero-po-lit-01&orientation=landscape"
          alt="po文学创作艺术背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 py-20">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium mb-6">
          网络创作新浪潮
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
          po文学
          <span className="block text-2xl md:text-3xl lg:text-4xl font-medium mt-3 text-background-200">
            碎片化时代的情绪写作
          </span>
        </h1>
        <p className="max-w-2xl mx-auto text-background-200 text-base md:text-lg leading-relaxed mb-8">
          深度解析po文学的起源、特征与创作技巧。从入门到进阶，掌握碎片化叙事与情绪共鸣的核心方法，写出刷屏爆款内容。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/rumen"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            开始学习
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/jiqiao"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-background-50/20 text-background-50 backdrop-blur-sm font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            创作技巧
            <i className="ri-quill-pen-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}